import { useCallback, useEffect } from "react";
import { useLocalStorageWithSubscription } from "../useLocalStorageWithSubscription";
import { usePreferredColorScheme } from "../usePreferredColorScheme";
import { THEME_LOCAL_STORAGE_KEY } from "./useTheme.constants";
const useTheme = () => {
    // Use our useLocalStorage hook to persist state through a page refresh.
    const [enabledState, setEnabledState] = useLocalStorageWithSubscription(THEME_LOCAL_STORAGE_KEY, undefined);
    // Check for the preferred color scheme of the user
    const preferredColorScheme = usePreferredColorScheme();
    // If enabledState is defined use it, otherwise fallback to the preferred color scheme.
    // This allows user to override OS level setting on our app.
    const theme = enabledState !== null && enabledState !== void 0 ? enabledState : preferredColorScheme;
    // Fire off effect that applies proper class to the `html` tag
    useEffect(() => {
        const doc = window.document.documentElement;
        const originalClasses = Array.from(doc.classList);
        if (theme === "dark") {
            doc.classList.add("dark");
            doc.classList.remove("light");
        }
        else {
            doc.classList.remove("dark");
            doc.classList.add("light");
        }
        // Cleanup function.
        return () => {
            doc.className = originalClasses.join(" ");
        };
    }, [theme] // Only re-call effect when value changes
    );
    const toggleTheme = useCallback(() => setEnabledState(theme === "dark" ? "light" : "dark"), [setEnabledState, theme]);
    // Return theme value and theme toggler
    return {
        theme,
        toggleTheme,
    };
};
export default useTheme;
